import { Link } from '@material-ui/core';
import { useIsAdminUser } from 'components/user/UserProvider';
import React, { FC } from 'react';

interface Props2 {
  displayPublicly: boolean;
  twitterId?: string;
  emailAddress: string;
  children: string;
}

const SubmitterName: FC<Props2> = ({ displayPublicly, twitterId, children, emailAddress }) => {
  const isAdminUser = useIsAdminUser();

  if (!displayPublicly && !isAdminUser) {
    return <>Anonymous</>;
  }

  return (
    <>
      {twitterId ? (
        <Link href={`https://www.twitter.com/${twitterId}`}>{children}</Link>
      ) : (
        <>{children}</>
      )}
      {isAdminUser && (
        <div>
          Contact: <Link href={`mailto: ${emailAddress}`}>{emailAddress}</Link>
        </div>
      )}
    </>
  );
};

export default SubmitterName;
